import React from "react";
import { toast } from "sonner";
import { IDS } from "@/constants/testIds";
import { Mail, Copy, ArrowUpRight } from "lucide-react";

const EMAIL = "info@aetheria.sh";

const Contact = () => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      toast.success(">>> email copied to clipboard");
    } catch {
      toast.error(">>> copy failed · select manually");
    }
  };

  return (
    <section
      id="contact"
      data-testid={IDS.contact}
      className="relative py-28 lg:py-40 border-t border-[rgba(0,255,65,0.12)] overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-30"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 50%, rgba(0,255,65,0.18), transparent 60%)",
        }}
      />
      <div className="mx-auto max-w-[1100px] px-6 lg:px-10 relative">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 border border-[rgba(0,255,65,0.4)] px-3 py-1.5 text-[10px] uppercase tracking-[0.3em] text-[#00FF41]">
            // 05 — Contact
          </div>
          <h2 className="mt-7 font-mono font-semibold tracking-tight text-white text-3xl sm:text-5xl lg:text-6xl leading-[1.04]">
            Got a chain to ship?
            <br />
            <span className="text-[#00FF41] glow-text">Let&apos;s talk.</span>
          </h2>
          <p className="mt-6 max-w-xl mx-auto text-zinc-400 text-sm sm:text-base">
            Drop us a line. We reply within one business day with a quick fit
            check and a scoping call invite — no salesperson, just engineers.
          </p>
        </div>

        <div className="mt-14 mx-auto max-w-[820px] pane">
          <div className="flex items-center justify-between px-5 py-2.5 border-b border-[rgba(0,255,65,0.2)] bg-black/40 text-[10px] uppercase tracking-[0.28em] text-zinc-500">
            <span>aetheria — contact.sh</span>
            <span className="text-[#00FF41]">● secure</span>
          </div>

          <div className="p-8 sm:p-12">
            <div className="font-mono text-[12px] uppercase tracking-[0.3em] text-zinc-500">
              <span className="text-[#00FF41]">root@aetheria:~$</span> mailto
            </div>

            <a
              href={`mailto:${EMAIL}`}
              data-testid={IDS.contactEmail}
              className="mt-5 inline-flex items-baseline gap-3 font-mono text-[#00FF41] glow-text text-2xl sm:text-4xl lg:text-5xl tracking-tight link-line"
            >
              <Mail
                size={28}
                strokeWidth={1.4}
                className="self-center text-[#00FF41]"
              />
              {EMAIL}
            </a>

            <div className="mt-10 flex flex-wrap items-center gap-3">
              <a
                href={`mailto:${EMAIL}?subject=Project%20inquiry%20—%20aetheria`}
                className="btn-term"
              >
                [ Send Email ]
                <ArrowUpRight size={14} strokeWidth={1.6} />
              </a>
              <button
                type="button"
                onClick={copy}
                data-testid={IDS.contactCopy}
                className="btn-term"
                data-variant="ghost"
              >
                <Copy size={14} strokeWidth={1.6} />
                Copy Address
              </button>
            </div>

            <div className="mt-10 pt-8 border-t border-[rgba(255,255,255,0.06)] grid sm:grid-cols-3 gap-6 text-[11px] uppercase tracking-[0.25em]">
              <Meta k="response" v="≤ 24h" />
              <Meta k="timezone" v="utc · async" />
              <Meta k="status" v="accepting · q1" green />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Meta = ({ k, v, green = false }) => (
  <div>
    <div className="text-zinc-500">// {k}</div>
    <div
      className={`mt-2 normal-case tracking-normal font-mono text-sm ${
        green ? "text-[#00FF41]" : "text-white"
      }`}
    >
      {v}
    </div>
  </div>
);

export default Contact;
